import {createSlice} from "@reduxjs/toolkit";
import {getHolidayList} from "./action";

const initialState = {
  state: [],
  loading: true,
  error: ''
} as BaseState<Holiday[]>

const slice = createSlice({
  name: 'couponSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getHolidayList.pending, (state) => ({
        ...state,
        loading: true
      })
    )
    builder.addCase(getHolidayList.fulfilled, (state, action) => {
        const items = action.payload
        return {
          state: [...items],
          loading: false,
          error: null
        }
      }
    )
    builder.addCase(getHolidayList.rejected, () => ({
        state: [],
        loading: false,
        error: 'Failed to get coupons, please try again'
      })
    )
  }
})

export default slice
